"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UALWombatError = void 0;
const universal_authenticator_library_1 = require("universal-authenticator-library");
const interfaces_1 = require("./interfaces");
function convertThrownToError(e) {
    if (e instanceof Error) {
        return e;
    }
    else if (typeof e === 'string') {
        return new Error(e);
    }
    else {
        return null;
    }
}
class UALWombatError extends universal_authenticator_library_1.UALError {
    constructor(message, type, cause) {
        super(message, type, convertThrownToError(cause), interfaces_1.Name);
    }
}
exports.UALWombatError = UALWombatError;
